module.exports = __webpack_public_path__ + "img/lemon_and_mint_3.11b4ba8b.png";